"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RenderableRefKeyStrings = void 0;
exports.RenderableRefKeyStrings = [
    "DESIGN",
    "FILE",
    "OPENING_SUGGESTION",
];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29yZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9jb3JlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQXlHYSxRQUFBLHVCQUF1QixHQUF1QjtJQUN6RCxRQUFRO0lBQ1IsTUFBTTtJQUNOLG9CQUFvQjtDQUNyQixDQUFDIn0=